import {DateRangeFilterTypes} from 'components/DateRange/utils';

export default {
  currentPrizeType: null,
  fetchingPrizes: false,
  isWinnerDetailModalOpen: false,
  dateRangeFilterType: DateRangeFilterTypes.LiveRange
};



// WEBPACK FOOTER //
// ./public/pages/ListPrizes/initialState.js